import { Link, Type, Wifi, Mail, Phone, MessageSquare, User } from 'lucide-react'
import { useI18n } from '../i18n'
import type { QRType } from '../lib/qrUtils'
import { cn } from '../lib/utils'

interface ContentTypeTabsProps {
  activeType: QRType
  onChange: (type: QRType) => void
}

const TABS: { type: QRType; icon: React.ReactNode }[] = [
  { type: 'url', icon: <Link className="w-4 h-4" /> },
  { type: 'text', icon: <Type className="w-4 h-4" /> },
  { type: 'wifi', icon: <Wifi className="w-4 h-4" /> },
  { type: 'email', icon: <Mail className="w-4 h-4" /> },
  { type: 'phone', icon: <Phone className="w-4 h-4" /> },
  { type: 'sms', icon: <MessageSquare className="w-4 h-4" /> },
  { type: 'vcard', icon: <User className="w-4 h-4" /> },
]

export function ContentTypeTabs({ activeType, onChange }: ContentTypeTabsProps) {
  const { t } = useI18n()

  return (
    <div className="flex flex-wrap gap-2">
      {TABS.map(({ type, icon }) => (
        <button
          key={type}
          onClick={() => onChange(type)}
          className={cn(
            'inline-flex items-center gap-1.5 px-3 py-2 rounded-full text-sm font-medium transition-all',
            activeType === type
              ? 'bg-primary text-primary-foreground shadow-sm'
              : 'bg-muted text-muted-foreground hover:bg-muted/80 border border-border'
          )}
        >
          {icon}
          <span>{t(`qr.types.${type}`)}</span>
        </button>
      ))}
    </div>
  )
}
